// Community Open Service Management APIs

/**
 * @function ApiClient#GetOpenServiceList
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} options = {}
 */
export async function GetOpenServiceList(cid, options = {}) {
  return await this._get(`/community/${cid}/open_service_list`, options);
}

/**
 * @function ApiClient#OpenService
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.deviceID
 * @param {any} params.cardUID
 * @param {any} options = {}
 */
export async function OpenService(cid, { building, doorPlate, floor, deviceID, cardUID }, options = {}) {
  let DeviceUID = "";
  let CardUID = "";
  if (deviceID) DeviceUID = deviceID;
  if (cardUID) CardUID = cardUID;

  return await this._put(`/community/${cid}/open_service?b=${building}&d=${doorPlate}&f=${floor}&i=${DeviceUID}&c=${CardUID}`, null, options);
}

/**
 * @function ApiClient#BindCardToUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} payload
 * @param {any} options = {}
 */
export async function BindCardToUser(cid, payload, options = {}) {
  return await this._put(`/community/${cid}/open_service/bind_user`, payload, options);
}

/**
 * @function ApiClient#SyncCardToTSM
 * @this {ApiClient}
 * @param {any} cid
 * @param {any} payload
 * @param {any} options = {}
 */
export async function SyncCardToTSM(cid, payload, options = {}) {
  return await this._put(`/community/${cid}/open_service/sync_tsm`, payload, options);
}

/**
 * @function ApiClient#GetUserActiveCode
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} options = {}
 */
export async function GetUserActiveCode(cid, { building, doorPlate, floor }, options = {}) {
  return await this._get(`/community/${cid}/open_service/activecode?b=${building}&d=${doorPlate}&f=${floor}`, options);
}

/**
 * @function ApiClient#DeleteHouseHoldUser
 * @this {ApiClient}
 * @param {any} cid
 * @param {object} params 參數。
 * @param {any} params.building
 * @param {any} params.doorPlate
 * @param {any} params.floor
 * @param {any} params.userID
 * @param {any} options = {}
 */
export async function DeleteHouseHoldUser(cid, { building, doorPlate, floor, userID }, options = {}) {
  return await this._delete(`/community/${cid}/open_service?b=${building}&d=${doorPlate}&f=${floor}&u=${userID}`, options);
}
